import { AdvisorySuiteBenefitClaim } from '@vdr/domains/advisory-suite/models/advisory-suite-benefit-claim.model';

export enum BalanceHistoryActivityType {
  RewardRedeemed,
  RewardRefund,
  RewardReopen,
  PointsAwarded,
}

export interface BalanceHistoryActivity {
  readonly activityAuthor: string;
  readonly rewardId: string;
  readonly type: BalanceHistoryActivityType;
}

export interface BalanceHistoryRecord {
  readonly activity: BalanceHistoryActivity;
  readonly balanceChange: number;
  readonly id: string;
  readonly remainingBalance: number;
  readonly reward?: AdvisorySuiteBenefitClaim;
  readonly timestamp: Date;
}
